var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { onMounted, onUnmounted, ref } from "vue";
import { GalaxyApi } from "@/api";
import { fetchDatasetDetails } from "@/api/datasets";
import {} from "@/api/jobs";
import { useConfig } from "@/composables/config";
import { useUserStore } from "@/stores/userStore";
import { errorMessageAsString } from "@/utils/simple-error";
import { stateIsTerminal } from "@/utils/utils";
import DatasetStorage from "@/components/Dataset/DatasetStorage/DatasetStorage.vue";
import DatasetInformation from "@/components/DatasetInformation/DatasetInformation.vue";
import InheritanceChain from "@/components/InheritanceChain//InheritanceChain.vue";
import JobDependencies from "@/components/JobDependencies/JobDependencies.vue";
import JobDestinationParams from "@/components/JobDestinationParams/JobDestinationParams.vue";
import JobInformation from "@/components/JobInformation/JobInformation.vue";
import JobMetrics from "@/components/JobMetrics/JobMetrics.vue";
import JobParameters from "@/components/JobParameters/JobParameters.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetDetails',
    props: {
        datasetId: null
    },
    setup(__props) {
        const props = __props;
        const { config, isConfigLoaded } = useConfig(true);
        const userStore = useUserStore();
        const { currentUser } = storeToRefs(userStore);
        const loading = ref(false);
        const jobTimeOut = ref(null);
        const jobDetails = ref();
        const dataset = ref(null);
        const jobLoadingError = ref(null);
        const datasetLoadingError = ref(null);
        function getDatasetDetails() {
            return __awaiter(this, void 0, void 0, function* () {
                loading.value = true;
                try {
                    const data = yield fetchDatasetDetails({ id: props.datasetId });
                    dataset.value = data;
                }
                catch (e) {
                    datasetLoadingError.value = errorMessageAsString(e) || "Unable to fetch available dataset details.";
                }
                finally {
                    loading.value = false;
                }
            });
        }
        function loadJobDetails() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const { data, error } = yield GalaxyApi().GET("/api/jobs/{job_id}", {
                    params: {
                        path: { job_id: (_a = dataset.value) === null || _a === void 0 ? void 0 : _a.creating_job },
                        query: { full: true },
                    },
                });
                if (error) {
                    jobLoadingError.value = errorMessageAsString(error);
                    return;
                }
                if (stateIsTerminal(data)) {
                    clearTimeout(jobTimeOut.value);
                }
                else {
                    jobTimeOut.value = setTimeout(loadJobDetails, 3000);
                }
                jobDetails.value = data;
            });
        }
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            var _a;
            yield getDatasetDetails();
            const creatingJobId = (_a = dataset.value) === null || _a === void 0 ? void 0 : _a.creating_job;
            if (creatingJobId) {
                yield loadJobDetails();
            }
        }));
        onUnmounted(() => {
            clearTimeout(jobTimeOut.value);
        });
        return { __sfc: true, props, config, isConfigLoaded, userStore, currentUser, loading, jobTimeOut, jobDetails, dataset, jobLoadingError, datasetLoadingError, getDatasetDetails, loadJobDetails, BAlert, DatasetStorage, DatasetInformation, InheritanceChain, JobDependencies, JobDestinationParams, JobInformation, JobMetrics, JobParameters, LoadingSpan };
    }
});
